import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface PlatformState {
  token: string | null
  setToken: (token: string) => void
  clearToken: () => void
}

export const usePlatformStore = create<PlatformState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token: token.trim() }),
      clearToken: () => set({ token: null }),
    }),
    {
      name: 'truemark-platform-token',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
